<template>
  <div class="tasksDetail">
    <div class="tasksDetail-top-bg "></div>
    <div class="tasksDetail-header">
      <van-image
        class="goback"
        width="0.267rem"
        height="0.5133rem"
        fit="contain"
        :src="bacImage"
        @click="goBack"
      />
      任务详情
    </div>
    <section class="item">
      <van-row>
        <van-col span="12">
          <div class="title van-ellipsis">
            {{ taskForm.ecompanyJobCategoryName }}
          </div>
        </van-col>
        <van-col span="12" class="gree van-ellipsis">
          <template v-if="taskForm.taskStatus == 'doing'">进行中</template>
          <template v-else>已关闭</template>
        </van-col>
      </van-row>
      <p class="van-ellipsis taskName">{{ taskForm.taskName }}</p>
      <p class="fee van-ellipsis">
        <template v-if="taskForm.taskMoney == '费用面议'">费用面议</template>
        <template v-if="taskForm.taskMoney == '固定价格'"
          >{{ taskForm.amount }}元</template
        >
        <template v-if="taskForm.taskMoney == '按月'"
          >{{ taskForm.amount }}元/月</template
        >
        <template v-if="taskForm.taskMoney == '按周'"
          >{{ taskForm.amount }}元/周</template
        >
        <template v-if="taskForm.taskMoney == '按天'"
          >{{ taskForm.amount }}元/天</template
        >
        <template v-if="taskForm.taskMoney == '按时'"
          >{{ taskForm.amount }}元/时</template
        >
      </p>
    </section>

    <section class="item taskInfo">
      <div class="title van-ellipsis">任务简介</div>
      <van-row>
        <van-col span="2">
          <van-image
            class="goback"
            width="0.32rem"
            height="0.32rem"
            fit="contain"
            :src="inconSettle"
          />
        </van-col>
        <van-col span="5" class="noWrap"> <span>结算方式</span>： </van-col>
        <van-col span="17" class="text-left van-ellipsis">
          {{ taskForm.settlement }}
        </van-col>
      </van-row>
      <van-row>
        <van-col span="2">
          <van-image
            class="goback"
            width="0.32rem"
            height="0.32rem"
            fit="contain"
            :src="inconAddress"
          />
        </van-col>
        <van-col span="5" class="noWrap">
          <span class="label">工作地点</span>：
        </van-col>
        <van-col span="17" class="text-left">
          {{ taskForm.cityName ? taskForm.cityName : '不限' }}
        </van-col>
      </van-row>
      <van-row>
        <van-col span="2">
          <van-image
            class="goback"
            width="0.32rem"
            height="0.32rem"
            fit="contain"
            :src="inconCompany"
          />
        </van-col>
        <van-col span="5" class="noWrap"> <span>发布企业</span>： </van-col>
        <van-col span="17" class="text-left van-ellipsis">
          {{ taskForm.ecompanyName }}
        </van-col>
      </van-row>
      <van-row>
        <van-col span="2">
          <van-image
            class="goback"
            width="0.32rem"
            height="0.32rem"
            fit="contain"
            :src="incontime"
          />
        </van-col>
        <van-col span="5" class="noWrap"> <span>发布时间</span>： </van-col>
        <van-col span="17" class="text-left van-ellipsis">
          {{ taskForm.publishDate }}
        </van-col>
      </van-row>
      <van-row>
        <van-col span="2">
          <van-image
            class="goback"
            width="0.32rem"
            height="0.32rem"
            fit="contain"
            :src="incontime"
          />
        </van-col>
        <van-col span="5" class="noWrap"> <span>截止时间</span>： </van-col>
        <van-col span="17" class="text-left van-ellipsis">
          <template v-if="taskForm.lastApplyDate == undefined"
            >长期有效</template
          >
          <template
            v-else-if="
              timeLeftCount(taskForm.lastApplyDate) <= 0 ||
                taskForm.applyStatus == 'stop'
            "
            >已截止</template
          >
          <template v-else>{{ taskForm.lastEndDate }}</template>
        </van-col>
      </van-row>
    </section>
    <section class="item taskInfoDetail">
      <p class="title">任务详情</p>
      <article v-html="taskForm.taskRemark"></article>
    </section>

    <div class="btn">
      <template v-if="taskForm.isApply">
        <van-button
          :disabled="!canApply"
          @click="submitApply"
          type="primary"
          round
          block
          v-if="
            taskForm.employeeTaskStatus == 'nopass' ||
              taskForm.employeeTaskStatus == 'finish' ||
              taskForm.employeeTaskStatus == 'cancelled'
          "
        >
          <span class="icon_toudi"></span>
          提交申请
        </van-button>

        <van-button
          type="info"
          round
          block
          v-else-if="taskForm.employeeTaskStatus == 'applying'"
          >已申请</van-button
        >
        <van-button
          type="warning"
          round
          block
          v-else-if="taskForm.employeeTaskStatus == 'doing'"
          >进行中</van-button
        >
      </template>
      <template v-else>
        <van-button
          type="danger"
          round
          block
          v-if="taskForm.employeeTaskStatus == 'nopass'"
          >不可申请</van-button
        >
        <template v-else>
          <van-button
            :disabled="!canApply"
            type="primary"
            round
            block
            @click="submitApply"
            v-if="taskForm.applyStatus == 'applying'"
          >
            <span class="icon_toudi"></span>提交申请
          </van-button>
          <van-button
            type="default"
            round
            block
            v-else-if="taskForm.applyStatus == 'stop'"
            >已截止</van-button
          >
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { getIndividualHeaderKey } from '@/utils/auth'
import jobHeaderSimple from '@/components/header/header.vue'
import { CountDown, Col, Row, Button, Toast, Image, Notify } from 'vant'
import { getByMobile, addTaskApply } from '@/api/contract/taskRequest'
import { aesDecrypt, aesEncrypt } from '@/utils/aes.js'
import store from '@/store'
export default {
  components: {
    jobHeaderSimple,
    [CountDown.name]: CountDown,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Image.name]: Image,
    [Notify.name]: Notify,
  },
  data() {
    return {
      taskId: this.$route.query.id,
      canApply: true,
      taskForm: {},
      bacImage: require('@/assets/images/icon-left-row.png'),
      inconSettle: require('@/assets/images/icon-settle.png'),
      inconCompany: require('@/assets/images/icon-company.png'),
      inconAddress: require('@/assets/images/icon-address.png'),
      incontime: require('@/assets/images/icon-time.png'),
      isShare: false, //是否是分享任务调转
      isLogin: true, //用户是否登录
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    //点击返回
    goBack() {
      // 个体户身份认证、视频认证、签名页等认证相关返回至个体户列表页
      if (
        getIndividualHeaderKey() &&
        this.$route.meta.identity === 'individual'
      ) {
        return this.$router.push('/individual_list')
      }
      if (window.history.length > 1) {
        if (this.$route.path == '/privacy') {
          if (this.$route.query.fromWhere == '/register') {
            localStorage.setItem('fromWhere', this.$route.query.fromWhere)
          }
        }
        return this.$router.go(-1)
      } else {
        return this.$router.push('/')
      }
    },
    getDetail() {
      let taskId = this.$route.query.id
      if (taskId !== '') {
        //    let temp = decodeURIComponent(taskId);//尝试解密
        const isNum = /^\d+$/.test(taskId)
        if (!isNum) {
         taskId = decodeURIComponent(taskId)
          //是扫码或者分享链接进入 非数字
          this.isShare = true
        }
      }
      getByMobile({ taskId: taskId }).then((res) => {
        if (res.data.status == 200) {
          this.taskForm = res.data.data
          this.isLogin = res.data.data.isLogin
          if (this.taskForm.taskStatus == 'doing') {
            this.canApply = true
          } else {
            this.canApply = false
          }
          if (this.taskForm != null) {
            //   if (this.taskForm.isApply){
            //       this.$router.push({ path: "/myTasksDetail", query: { id: this.$route.query.id } });
            //   }
            /*if(this.taskForm.applyStatus==='applying'){
                    this.$router.push({ path: "/myTasksDetail", query: { id: this.$route.query.id } });
                }else{
                    if (
                    (!this.taskForm.isApply &&
                        this.taskForm.applyStatus == "applying" &&
                        this.taskForm.employeeTaskStatus != "nopass") ||
                    (this.taskForm.isApply &&
                        (this.taskForm.employeeTaskStatus == "nopass" ||
                        this.taskForm.employeeTaskStatus == "finish" ||
                        this.taskForm.employeeTaskStatus == "cancelled"))
                    ) {
                    this.disabledFlag = false;
                    } else {
                    this.disabledFlag = true;
                    }
                }*/
            if (this.taskForm.isApply) {
              const timeLeft =
                store.getters.jwtDecode.exp - Math.round(new Date() / 1000)
              if (timeLeft > 0) {
                this.$router.push({
                  path: '/myTasksDetail',
                  query: { id: this.taskForm.id },
                })
              }
            }
          }
        } else {
          this.$notify({
            message: res.data.message,
            type: 'danger',
            duration: 2000,
          })
        }
      })
    },
    submitApply() {
      if (!this.isLogin && this.isShare) {
        let param = {
          path: '/simpleRegister',
          query: {
            taskId: this.taskId,
          },
        }
        this.$router.push(param)
      } else {
        this.canApply = false
        this.$store.commit('SET_ENTERROUTE', this.$route.fullPath)
        // Toast.loading({
        //   duration: 4000, // 持续展示 toast
        //   message: "加载中...",
        //   forbidClick: true,
        // });
        addTaskApply({ taskId: this.taskForm.id })
          .then((res) => {
            if (res.data.status == 200) {
              this.$notify({
                message: '申请成功',
                type: 'success',
                duration: 2000,
              })
              this.getDetail()
            } else {
              this.canApply = true
              let message = res.data.message
              if (res.data.data != null) {
                for (let key in res.data.data) {
                  message = res.data.data[key]
                }
              }
              this.$notify({
                message: message,
                type: 'danger',
                duration: 2000,
              })
            }
            Toast.clear()
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    timeLeftCount(data) {
      return new Date(data.replace(/-/g, '/')).getTime() - new Date().getTime()
    },
  },
}
</script>

<style lang="less" scoped>
.noWrap {
  white-space: nowrap;
}
.tasksDetail-top-bg {
  top: 0;
  position: fixed;
  height: 238px;
  width: 100%;
  background: #9ebdec;
  background: -webkit-linear-gradient(top, #9ebdec 0, #faf8fc 100%);
  background: -moz-linear-gradient(top, #9ebdec 0, #faf8fc 100%);
  background: -o-linear-gradient(top, #9ebdec 0, #faf8fc 100%);
  background: linear-gradient(to bottom, #9ebdec 0, #faf8fc 100%);
}
.tasksDetail-header {
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  position: fixed;
  font-size: 16px;
  top: 0;
  left: 0;
  z-index: 9;
  background: #9ebdec;
  background: -webkit-linear-gradient(top, #9ebdec 0, #aac4ef 100%);
  background: -moz-linear-gradient(top, #9ebdec 0, #aac4ef 100%);
  background: -o-linear-gradient(top, #9ebdec 0, #aac4ef 100%);
  background: linear-gradient(to bottom, #9ebdec 0, #aac4ef 100%);
  font-family: 'SourceHanSansSC-Medium';
  color: rgb(51, 51, 51);
  .goback {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.tasksDetail-top {
  background: #aac4ef;
  background: -webkit-linear-gradient(top, #aac4ef 0, #faf8fc 100%);
  background: -moz-linear-gradient(top, #aac4ef 0, #faf8fc 100%);
  background: -o-linear-gradient(top, #aac4ef 0, #faf8fc 100%);
  background: linear-gradient(to bottom, #aac4ef 0, #faf8fc 100%);
  padding-bottom: 137px;
}
.tasksDetail > .van-row {
  background: #ddd;
  font-size: 14px;
  padding: 12px 12px 20px;
  line-height: 24px;
  &.colorFul {
    background: #6c7ef3;
    color: #fff;
  }
}
section {
  margin: 8px;
  background: #fff;
  border-radius: 8px;
  font-size: 14px;
  line-height: 22px;
  padding: 12px;

  header {
    line-height: 40px;
    color: #333;
    border-bottom: 1px solid #eee;
    margin: -6px 0 6px;
  }

  article {
    font-size: 12px;
    word-break: break-all;
    word-wrap: break-word;
    /deep/ img {
      display: block;
      width: 100%;
      height: auto;
    }
    /deep/ p {
      margin-bottom: 6px;
    }
  }
}

.btn {
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 8px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;

  .icon_toudi {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    background: url(../../assets/icon_send.svg) center center/contain no-repeat;
  }
}
.item {
  position: relative;
  margin: 0 8px 8px;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  color: #666;
  padding: 12px;
  z-index: 8;
  &.taskInfo {
    // margin-top: -137px;
    font-size: 11px;
    color: rgb(51, 51, 51);
    .title {
      margin-bottom: 8px;
    }

    .text-left {
      text-align: left;
    }
  }
  &.taskInfoDetail {
    .title {
      margin-bottom: 6px;
    }
  }
  .taskName {
    margin: 6px 0;
  }
  .title {
    color: #333;
    font-size: 18px;
    font-weight: 800;
  }
  .fee {
    color: #f3852c;
    font-weight: 800;
    font-size: 15px;
  }
  p {
    &.linecenter {
      margin: 12px;
      color: rgb(51, 51, 51);
    }
  }
  /deep/ .van-row {
    font-size: 14px;
    line-height: 30px;

    .title {
      color: #333;
      font-size: 18px;
    }
    .gree {
      color: rgb(110, 150, 207);
      text-align: right;
      padding-right: 10px;
      font-size: 15px;
      font-weight: 800;
    }
  }

  .type {
    float: right;
    margin-left: 6px;
  }

  .icon {
    position: relative;
    top: 2px;
  }

  /deep/ .van-button {
    width: 80px;
    position: absolute;
    right: 12px;
    bottom: 20px;
  }
}
</style>
